(function () {
  'use strict';

  var targetSelector = '[data-fa-loox-id]';
  var ratingCache = new Map();
  var waitingTargets = new Map();
  var scheduled = false;
  var inFlight = false;
  var configRetryCount = 0;
  var maxConfigRetries = 40;
  var maxBatchSize = 50;
  var starGap = 4;
  var starSize = 14;

  function normalizeRating(rating, count, id) {
    var normalizedCount = Number(count);
    var normalizedRating = Number(rating);

    if (!Number.isFinite(normalizedCount) || normalizedCount < 0) normalizedCount = 0;
    normalizedCount = Math.floor(normalizedCount);

    if (!Number.isFinite(normalizedRating) || normalizedRating < 0 || normalizedRating > 5 || normalizedCount === 0) {
      normalizedRating = 0;
    }

    return {
      id: String(id || ''),
      rating: normalizedRating,
      count: normalizedCount
    };
  }

  function getMetafield(product, key) {
    var metafields = product && Array.isArray(product.metafields) ? product.metafields : [];
    for (var index = 0; index < metafields.length; index += 1) {
      if (metafields[index].namespace === 'loox' && metafields[index].key === key) {
        return metafields[index].value;
      }
    }
    return '';
  }

  function normalizeProductEndpoint(payload) {
    var product = payload && payload.product ? payload.product : null;
    return normalizeRating(
      getMetafield(product, 'avg_rating'),
      getMetafield(product, 'num_reviews'),
      product && product.id
    );
  }

  function getLooxConfig() {
    var loox = window.LOOX;
    if (!loox || !loox.root || !loox.clientId || !loox.hash) return null;
    return {
      root: String(loox.root).replace(/\/$/, ''),
      clientId: String(loox.clientId),
      hash: String(loox.hash)
    };
  }

  function getStarFillWidth(rating) {
    var clampedRating = Math.max(0, Math.min(5, Number(rating) || 0));
    var fullStars = Math.floor(clampedRating);
    var fillWidth = fullStars * starSize + Math.min(fullStars, 4) * starGap;

    if (fullStars < 5) {
      fillWidth += (clampedRating - fullStars) * starSize;
    }

    return Math.round(fillWidth * 100) / 100;
  }

  function removeNode(node) {
    if (!node) return;
    if (typeof node.remove === 'function') {
      node.remove();
      return;
    }
    if (node.parentNode && typeof node.parentNode.removeChild === 'function') {
      node.parentNode.removeChild(node);
    }
  }

  function removeRatingTarget(target) {
    var wrapper = target && target.parentElement;
    if (
      wrapper &&
      typeof wrapper.matches === 'function' &&
      wrapper.matches('a.loox-rating-link') &&
      wrapper.childElementCount === 1
    ) {
      removeNode(wrapper);
      return;
    }
    removeNode(target);
  }

  function renderRating(target, product) {
    var requestedId = target.getAttribute('data-fa-loox-id');
    if (requestedId && product.id && requestedId !== product.id) {
      throw new Error('Loox returned the wrong product rating');
    }

    if (!product || product.count <= 0 || product.rating <= 0) {
      removeRatingTarget(target);
      return;
    }

    var fillWidth = getStarFillWidth(product.rating);
    var ratingLabel = product.rating.toFixed(1);
    var reviewLabel = product.count + (product.count === 1 ? ' reseña' : ' reseñas');
    var visibleReviewLabel = target.getAttribute('data-fa-loox-compact') === 'true'
      ? '(' + product.count + ')'
      : reviewLabel;

    target.className = 'fa-loox-static-rating';
    target.setAttribute('data-fa-loox-state', 'ready');
    target.setAttribute('data-rating', String(product.rating));
    target.setAttribute('data-raters', String(product.count));
    target.setAttribute('role', 'img');
    target.setAttribute('aria-label', ratingLabel + ' estrellas de 5, ' + reviewLabel);
    target.innerHTML = '<span class="fa-loox-static-stars" aria-hidden="true" style="--fa-loox-fill:' + fillWidth + 'px"></span><span class="fa-loox-static-count">' + visibleReviewLabel + '</span>';
  }

  function settleRating(id, rating) {
    ratingCache.set(id, rating);
    var targets = waitingTargets.get(id) || [];
    waitingTargets.delete(id);
    for (var index = 0; index < targets.length; index += 1) {
      try {
        renderRating(targets[index], rating);
      } catch (error) {
        removeRatingTarget(targets[index]);
      }
    }
  }

  function failRating(id) {
    var targets = waitingTargets.get(id) || [];
    waitingTargets.delete(id);
    for (var index = 0; index < targets.length; index += 1) {
      removeRatingTarget(targets[index]);
    }
  }

  function loadProductEndpoint(id) {
    var targets = waitingTargets.get(id) || [];
    var handle = targets.length ? targets[0].getAttribute('data-fa-loox-handle') : '';
    if (!handle) return Promise.reject(new Error('Missing product handle'));

    return fetch('/products/' + encodeURIComponent(handle) + '?view=details-endpoint', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Loox product endpoint returned ' + response.status);
      return response.json();
    }).then(normalizeProductEndpoint).then(function (rating) {
      settleRating(id, rating);
    });
  }

  function fallbackBatch(ids) {
    return Promise.all(ids.map(function (id) {
      return loadProductEndpoint(id).catch(function () {
        failRating(id);
      });
    }));
  }

  function buildRatingsUrl(config, ids) {
    return config.root + '/widget/' + encodeURIComponent(config.clientId) + '/ratings?products_ids=' + encodeURIComponent(ids.join(',')) + '&h=' + encodeURIComponent(config.hash);
  }

  function scheduleFlush(delay) {
    if (scheduled || inFlight) return;
    scheduled = true;
    setTimeout(function () {
      scheduled = false;
      flushQueue();
    }, delay || 0);
  }

  function flushQueue() {
    if (inFlight || waitingTargets.size === 0) return;

    var ids = Array.from(waitingTargets.keys()).slice(0, maxBatchSize);
    var config = getLooxConfig();
    if (!config) {
      configRetryCount += 1;
      if (configRetryCount <= maxConfigRetries) {
        scheduleFlush(Math.min(1000, 100 + configRetryCount * 50));
      } else {
        inFlight = true;
        fallbackBatch(ids).finally(function () {
          inFlight = false;
          scheduleFlush();
        });
      }
      return;
    }

    configRetryCount = 0;
    inFlight = true;
    fetch(buildRatingsUrl(config, ids), {
      credentials: 'omit',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Loox ratings endpoint returned ' + response.status);
      return response.json();
    }).then(function (payload) {
      if (!payload || payload.success !== true || !Array.isArray(payload.ratings)) {
        throw new Error('Loox ratings endpoint returned invalid data');
      }

      var ratingsById = new Map();
      for (var index = 0; index < payload.ratings.length; index += 1) {
        var entry = payload.ratings[index];
        var id = String(entry && entry.pid ? entry.pid : '');
        if (id) ratingsById.set(id, normalizeRating(entry.rating, entry.raters, id));
      }

      for (var idIndex = 0; idIndex < ids.length; idIndex += 1) {
        var productId = ids[idIndex];
        settleRating(productId, ratingsById.get(productId) || normalizeRating(0, 0, productId));
      }
    }).catch(function () {
      return fallbackBatch(ids);
    }).finally(function () {
      inFlight = false;
      scheduleFlush();
    });
  }

  function hydrateTarget(target) {
    if (!target || target.getAttribute('data-fa-loox-state')) return;

    var id = target.getAttribute('data-fa-loox-id');
    if (!id) return;
    id = String(id);

    if (ratingCache.has(id)) {
      renderRating(target, ratingCache.get(id));
      return;
    }

    target.setAttribute('data-fa-loox-state', 'queued');
    if (!waitingTargets.has(id)) waitingTargets.set(id, []);
    waitingTargets.get(id).push(target);
    scheduleFlush();
  }

  function scan(root) {
    if (!root) return;
    if (root.nodeType === 1 && root.matches(targetSelector)) hydrateTarget(root);
    if (!root.querySelectorAll) return;

    var targets = root.querySelectorAll(targetSelector);
    for (var index = 0; index < targets.length; index += 1) hydrateTarget(targets[index]);
  }

  function start() {
    scan(document);
    new MutationObserver(function (mutations) {
      for (var mutationIndex = 0; mutationIndex < mutations.length; mutationIndex += 1) {
        var nodes = mutations[mutationIndex].addedNodes;
        for (var nodeIndex = 0; nodeIndex < nodes.length; nodeIndex += 1) scan(nodes[nodeIndex]);
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();

(function () {
  'use strict';

  var selector = 'loox-snippets-widget';
  var mounted = new WeakSet();
  var css = '.image{width:60px!important;height:60px!important;min-width:60px!important;max-width:60px!important;min-height:60px!important;max-height:60px!important;flex:0 0 60px!important;object-fit:cover;overflow:hidden;font-size:0!important;color:transparent!important}.image[data-fa-image-failed]{visibility:hidden!important}';

  function mount(widget) {
    if (mounted.has(widget)) return;
    mounted.add(widget);
    Promise.resolve(widget.updateComplete).then(function () {
      var root = widget.shadowRoot;
      if (!root) return;

      function updateImage(image) {
        if (!image.matches('img.image')) return;
        image.toggleAttribute('data-fa-image-failed', image.complete && image.naturalWidth === 0);
      }

      function refresh() {
        if (!root.querySelector('[data-fa-snippet-image-guard]')) {
          var style = document.createElement('style');
          style.setAttribute('data-fa-snippet-image-guard', '20261030');
          style.textContent = css;
          root.appendChild(style);
        }
        root.querySelectorAll('img.image').forEach(updateImage);
      }

      root.addEventListener('error', function (event) {
        if (event.target instanceof HTMLImageElement) updateImage(event.target);
      }, true);
      root.addEventListener('load', function (event) {
        if (event.target instanceof HTMLImageElement) updateImage(event.target);
      }, true);
      new MutationObserver(refresh).observe(root, {
        childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'srcset']
      });
      refresh();
    });
  }

  function scan(node) {
    if (node.nodeType !== 1 && node.nodeType !== 9) return;
    if (node.matches && node.matches(selector)) mount(node);
    node.querySelectorAll(selector).forEach(mount);
  }

  if (!window.customElements) return;
  customElements.whenDefined(selector).then(function () {
    scan(document);
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) { mutation.addedNodes.forEach(scan); });
    }).observe(document.documentElement, { childList: true, subtree: true });
  });
})();
